class PaymentProviderModelConsts {
  public static readonly NameMinLength: number = 1;

  public static readonly NameMaxLength: number = 100;

  public static readonly DescriptionMaxLength: number = 1000;
}

export default PaymentProviderModelConsts;
